/* =========================================================================
   EGONEX — Canlı destek widget'ı
   ========================================================================= */
(function () {
  'use strict';

  class EgonexSupport extends HTMLElement {
    connectedCallback() {
      this.fab = this.querySelector('[data-eg-support-toggle]');
      this.panel = this.querySelector('[data-eg-support-panel]');
      this.hello = this.querySelector('[data-eg-support-hello]');

      this.fab?.addEventListener('click', () => this.toggle());
      this.querySelector('[data-eg-support-close]')?.addEventListener('click', () => this.close());
      this.querySelector('[data-eg-support-hello-close]')?.addEventListener('click', (e) => {
        e.stopPropagation();
        this.dismissHello();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
      });

      document.addEventListener('click', (e) => {
        if (this.classList.contains('is-open') && !this.contains(e.target)) this.close();
      });

      // Sepet / menü çekmecesi açılınca alta gizlen
      document.addEventListener('eg:overlay:open', () => this.tuck(true));
      document.addEventListener('eg:overlay:close', () => this.tuck(false));

      this.setupHours();
      this.scheduleHello();
    }

    toggle() {
      this.classList.contains('is-open') ? this.close() : this.open();
    }

    open() {
      this.classList.add('is-open');
      if (this.panel) this.panel.hidden = false;
      this.fab?.setAttribute('aria-expanded', 'true');
      this.dismissHello(true);
      setTimeout(() => this.querySelector('.eg-support__channel')?.focus(), 220);
    }

    close() {
      this.classList.remove('is-open');
      this.fab?.setAttribute('aria-expanded', 'false');
      setTimeout(() => {
        if (this.panel && !this.classList.contains('is-open')) this.panel.hidden = true;
      }, 200);
    }

    tuck(state) {
      this.classList.toggle('is-tucked', !!state);
      if (state) this.close();
    }

    /* Karşılama balonu */
    scheduleHello() {
      if (!this.hello) return;
      let dismissed = false;
      try {
        dismissed = window.sessionStorage.getItem('eg-support-hello') === 'off';
      } catch (e) {
        /* sessiz geç */
      }
      if (dismissed) return;

      const delay = parseInt(this.dataset.openDelay, 10) || 4000;
      this.helloTimer = setTimeout(() => {
        if (!this.classList.contains('is-open')) this.hello.hidden = false;
      }, delay);
    }

    dismissHello(soft) {
      clearTimeout(this.helloTimer);
      if (this.hello) this.hello.hidden = true;
      if (soft) return;
      try {
        window.sessionStorage.setItem('eg-support-hello', 'off');
      } catch (e) {
        /* sessiz geç */
      }
    }

    /* Çalışma saatleri */
    setupHours() {
      if (this.dataset.hours !== 'true') return;
      const status = this.querySelector('[data-eg-support-status]');
      const text = this.querySelector('[data-eg-support-status-text]');
      if (!status || !text) return;

      const start = parseInt(this.dataset.hourStart, 10);
      const end = parseInt(this.dataset.hourEnd, 10);
      const hour = new Date().getHours();
      const online = hour >= start && hour < end;

      status.classList.toggle('is-offline', !online);
      if (!online) {
        const offline = status.getAttribute('data-offline-text');
        text.textContent = offline || `Şu an kapalıyız · ${start}:00 - ${end}:00 arası yanıtlıyoruz`;
      }
    }
  }

  if (!customElements.get('egonex-support')) customElements.define('egonex-support', EgonexSupport);
})();
